import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/coach/dashboard.module.scss";
import { useNavigate } from "react-router-dom";
import { coachRoutes } from "../../routers/CoachRouters";
import { Performance } from "../report";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../../redux";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.navbar.button);

  const createBiometric = () => {
    navigate(coachRoutes.createBiometricExerciseReport);
  };
  const createExercise = () => {
    // Logic to create exercise
    navigate(coachRoutes.createBiometricExerciseReport);
  };
  const sendReport = () => {
    navigate(coachRoutes.listClient);
  };
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  return (
    <>
      <Navbar />
      <div
        className={Styles.dashboard_list_container_main}
        onClick={handleMainContainerClick}
      >
        <div className={Styles.dashboard_list_container}>
          <div className={Styles.dashboard_top_bar}>
            <div className={Styles.dashboard_top_bar_flex}>
              <div
                onClick={createBiometric}
                className={Styles.dashboard_top_bar_flex_child}
              >
                <h1>BIOMETRIC</h1>
              </div>

              <div
                onClick={createExercise}
                className={Styles.dashboard_top_bar_flex_child}
              >
                <h1>EXERCISE</h1>
              </div>

              <div
                onClick={sendReport}
                className={Styles.dashboard_top_bar_flex_child}
              >
                <h1>SEND REPORT</h1>
              </div>
            </div>
          </div>
        </div>
        <Performance />
      </div>
    </>
  );
};

export default Dashboard;
